import * as React from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  Autocomplete,
  Checkbox,
  TextField,
  Box,
  CircularProgress,
} from "@mui/material";
import { useGetSkillsQuery } from "../../services/skill.service";
import { Skill } from "../../types/skill";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SelectSkills = ({
  onChange,
  values,
}: {
  onChange: (ids?: number[]) => void;
  values: number[];
}) => {
  const { data: skills, isLoading, isFetching } = useGetSkillsQuery();

  const initialSkills = React.useMemo(
    () => skills?.filter((it) => values?.includes(it.id)),
    [skills, values]
  );

  return (
    <Autocomplete
      multiple
      fullWidth
      id="checkboxes-tags"
      options={skills || []}
      disableCloseOnSelect
      ChipProps={{ color: "secondary" }}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label="Skills" placeholder="Search..." />
      )}
      loading={isLoading}
      onChange={(event: any, newValue: Skill[] | null) => {
        onChange(newValue?.map((it) => it.id));
      }}
      value={initialSkills || []}
    />
  );
};
export default SelectSkills;
